import { useCallback } from 'react';

import { resolveOfferDayPartUnavailableMessage } from 'experiments/deeplinks-flow-feature/treatment/features/offer/utils/resolve-offer-day-part-unavailable-message';
import { useMainMenuContext } from 'state/menu/main-menu';

const NO_ACTIVE_DAY_PARTS: never[] = [];

/**
 * Resolves the "only available on <dayparts>" message for a deeplinked offer
 * against the selected restaurant's currently active dayparts.
 */
export function useOfferDayPartAvailability() {
  const {
    activeDayParts = NO_ACTIVE_DAY_PARTS,
    isDayPartsSourceResolved = false,
  } = useMainMenuContext();

  const getDayPartUnavailableMessage = useCallback(
    (offer: { daypart?: readonly (string | null | undefined)[] | null } | undefined) =>
      resolveOfferDayPartUnavailableMessage({
        offer,
        activeDayParts,
        isDayPartsSourceResolved,
      }),
    [activeDayParts, isDayPartsSourceResolved]
  );

  return { getDayPartUnavailableMessage };
}
